import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { MenuItem } from '../models';

@Component({
    selector: 'onego-menu-title-icon',
    templateUrl: './onego-menu-title-icon.component.html',
    styleUrls: ['./onego-menu-title-icon.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OneGoMenuTitleIconComponent {
    public readonly item = input.required<MenuItem>();
}
